import { defineStore } from 'pinia';

export const useStore = defineStore({
  id: 'global',

  state: () => {
    return {
      isProcessingOrder: false,
      isLoaderActive: false,
    };
  },

  actions: {
    setIsProcessingOrder(isProcessing: boolean) {
      this.isProcessingOrder = isProcessing;
    },
    setIsLoaderActive(isLoading: boolean) {
      this.isLoaderActive = isLoading;
    },
  },
});
